var _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAF1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 27V25H14V18C14 16.6167 14.4167 15.3875 15.25 14.3125C16.0833 13.2375 17.1667 12.5333 18.5 12.2V11.5C18.5 11.0833 18.6458 10.7292 18.9375 10.4375C19.2292 10.1458 19.5833 10 20 10C20.4167 10 20.7708 10.1458 21.0625 10.4375C21.3542 10.7292 21.5 11.0833 21.5 11.5V12.2C22.8333 12.5333 23.9167 13.2375 24.75 14.3125C25.5833 15.3875 26 16.6167 26 18V25H28V27H12ZM20 30C19.45 30 18.9792 29.8042 18.5875 29.4125C18.1958 29.0208 18 28.55 18 28H22C22 28.55 21.8042 29.0208 21.4125 29.4125C21.0208 29.8042 20.55 30 20 30ZM16 25H24V18C24 16.9 23.6083 15.9583 22.825 15.175C22.0417 14.3917 21.1 14 20 14C18.9 14 17.9583 14.3917 17.175 15.175C16.3917 15.9583 16 16.9 16 18V25Z",
    fill: "#245775"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 14,
    r: 5.5,
    fill: "#73B76F",
    stroke: "#EAF1F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotificationIcon);
export default __webpack_public_path__ + "static/media/newNotificationIcon.6d1c50bd45720e2033b3fcbc4488975f.svg";
export { ForwardRef as ReactComponent };